module.exports = {"131128100":"阜城镇","131128101":"古城镇","131128102":"码头镇","131128103":"霞口镇","131128104":"崔家庙镇","131128105":"漫河镇","131128201":"建桥乡","131128202":"蒋坊乡","131128203":"大白乡","131128204":"王集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131128.json
// module id = 252
// module chunks = 0